import axios from "axios";
import { accessTokenAtom } from "@/store/atoms/authAtoms";
import { myStore } from "@/main";
import { AUTH_EVENTS, authEvents } from "@/utils/authEvents";

const api = axios.create({
  baseURL: `${import.meta.env.VITE_REACT_APP_API_ENDPOINT}`,
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    const token = myStore.get(accessTokenAtom);
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const { data } = await axios.post(
          `${import.meta.env.VITE_REACT_APP_API_ENDPOINT}/auth/refresh`,
          {},
          {
            withCredentials: true,
          }
        );

        const newAccessToken = data.accessToken;
        myStore.set(accessTokenAtom, newAccessToken);
        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;

        return api(originalRequest);
      } catch (refreshError) {
        myStore.set(accessTokenAtom, null);
        authEvents.emit(AUTH_EVENTS.SESSION_EXPIRED);
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
